export const Phone = ({ children, testId }) => (
  <div className="phone" data-testid={testId}>
    <div className="phone-notch" />
    <div className="phone-status">
      <span>9:41</span>
      <span className="flex gap-1 items-center">
        <i className="w-3 h-1.5 bg-[var(--navy)] rounded-sm inline-block" />
        <i className="w-1.5 h-1.5 bg-[var(--navy)] rounded-full inline-block" />
      </span>
    </div>
    <div className="phone-screen">{children}</div>
  </div>
);

export const AppTabBar = ({ active }) => (
  <div className="app-tabbar">
    {["Home", "Prenota", "Carta", "Luxury"].map((t) => (
      <span key={t} className={t === active ? "text-[var(--gold)] font-semibold" : ""}>
        <i className={`block mx-auto mb-1 w-1.5 h-1.5 rotate-45 ${t === active ? "bg-[var(--gold)]" : "bg-[#C9C2B4]"}`} />
        {t}
      </span>
    ))}
  </div>
);

export const Browser = ({ children, testId }) => (
  <div className="browser" data-testid={testId}>
    <div className="browser-bar">
      <span className="flex gap-1.5">
        <i className="w-2.5 h-2.5 rounded-full bg-[#E3D6BE] inline-block" />
        <i className="w-2.5 h-2.5 rounded-full bg-[#E3D6BE] inline-block" />
        <i className="w-2.5 h-2.5 rounded-full bg-[#E3D6BE] inline-block" />
      </span>
      <span className="browser-url">Portale Aziende · Bella Napoli</span>
      <span className="w-12" />
    </div>
    {children}
  </div>
);
